<div class="container">
    <dxo-card style="width:100%">
        <card-body>
            <div class="data-containter">
                <img src="/assets/images/no-content.png" alt="no data available." class="img-no-content" />
                <h3 class="label-message">{{message}}</h3>
            </div>
        </card-body>
    </dxo-card>
</div>